/* eslint-disable react/display-name */

import React, { useRef } from 'react';
import routes from '@achievable-me/tundra-wizard/routes';
import { reverse } from 'named-urls';
import ProductLayout from '$components/layout/ProductLayout';
import ScrollToTop from '$components/library/ScrollToTop';
import Title from '$components/library/Title';
import Seo from '$components/Seo';
import SiePodcast from './SiePodcast';
import S7Podcast from './S7Podcast';
import VideoLibrary from './VideoLibrary';
import styles from './styles.scss';
import { useTrack } from '$lib/tracking';

const getTutorComponent = ({ productSlug }) => {
  switch (productSlug) {
    case 'finra-sie':
      return SiePodcast;
    case 'finra-series-7':
      return S7Podcast;
    default:
      return () => <div>No resources currently available for this course.</div>;
  }
};

const ResourcesContent = (props) => {
  const { product } = props;
  const layoutRef = useRef();
  const { slug: productSlug } = product;
  useTrack('Resources page | Viewed', {
    productSlug,
  });
  const TutorComponent = getTutorComponent({ productSlug });

  return (
    <ScrollToTop elementRef={layoutRef}>
      <div ref={layoutRef} className={styles.layout}>
        <Seo
          title="Resources"
          canonical={reverse(routes.study.resources, { productSlug })}
          description="View our collection of curated additional resources to help you out during your studying."
        />
        <VideoLibrary productSlug={productSlug} />
        <Title size="monkey">Additional resources</Title>
        <TutorComponent />
      </div>
    </ScrollToTop>
  );
};

const Resources = (props) => {
  const { currentUser, location, match } = props;

  return (
    <ProductLayout currentUser={currentUser} location={location} match={match}>
      {({ product }) => <ResourcesContent product={product} />}
    </ProductLayout>
  );
};

export default Resources;
